import React, { useContext, useState } from "react";
import login from "../../images/login2.jpg";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { context } from "../FrontPanel/FrontPanel";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import { HiOutlineX } from "react-icons/hi";
function Login() {
  const {
    update,
    setUpdate,
    setIsSignedIn,
    pharmacyDataDetails,
    cart,
    loginModalIsOpen,
    setIsLoginOpen,
    isRegister,
    setIsRegister,
  } = useContext(context);
  const [userInfo, setuserInfo] = useState({
    email: "",
    name: "",
    phone: "",
    password: "",
    password_confirmation: "",
    rememberme: false,
    user_type: "customer",
    verification_code: "",
  });
  const from = useLocation();
  const navigate = useNavigate();
  const [isVissible, setIsVissible] = useState(false);
  const isPhone =
    userInfo.email.startsWith("01") || userInfo.email.startsWith("+8801");

  const submitForm = (e) => {
    e.preventDefault();
    axios
      .post(
        "/login",
        isPhone
          ? { phone_number: userInfo.email, password: userInfo.password }
          : { email: userInfo.email, password: userInfo.password }
      )
      .then((res) => {
        if (res.data.user?.user_type === "customer") {
          if (userInfo.rememberme) {
            localStorage.setItem("user", JSON.stringify(res.data));
          }
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            text: "Successfully logged in !",
            timer: 2500,
          });
          sessionStorage.setItem("user", JSON.stringify(res.data));
          if (cart.length > 0) {
            navigate(`/checkout/${pharmacyDataDetails.seller_id}`);
          } else {
            navigate(from.state ? from.state : "/");
          }
          navigate(from.state);
          setUpdate(!update);
          setIsSignedIn(true);
          setIsLoginOpen(false);
        } else {
          Swal.fire({
            position: "top-center",
            icon: "error",
            title: "Error !",
            text: "Opps ! Invalid credentials",
            timer: 2500,
          });
        }
      })
      .catch((err) => {
        console.log(err, "error");
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: "Error !",
          text: `${err.response.data.message}`,
          timer: 8500,
        });
      });
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "5px",
      maxHeight: "649px",
      minHeight: "350px",
    },
  };
  const [token, setToken] = useState("");
  const handleSendVerification = () => {
    if (userInfo.phone_number) {
      axios
        .post(`/send-verification-code`, {
          phone_number: userInfo.phone_number,
        })
        .then((res) => {
          setToken(res.data.token);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            text: "Verification code sent !",
            timer: 2500,
          });
          setIsCodeSend(true);
        })
        .catch((err) => {
          Swal.fire({
            position: "top-center",
            icon: "error",
            title: "Error !",
            text: `${err.response.data.message}`,
            timer: 8500,
          });
        });
    }
  };
  const [isVerified, setVerified] = useState("");
  const [isCodeSend, setIsCodeSend] = useState(false);
  const handleVerificationCheck = () => {
    if (userInfo.verification_code) {
      axios
        .post(`/verification-check`, {
          verification_code: userInfo.verification_code,
          phone_number: userInfo.phone_number,
          token: token,
        })
        .then((res) => {
          setVerified("yes");
        })
        .catch((err) => {
          setVerified("no");
        });
    }
  };

  const submitRegForm = (e) => {
    e.preventDefault();
    if (isVerified === "no") {
      Swal.fire({
        position: "top-center",
        icon: "error",
        title: "Error !",
        text: "Opps ! Enter correct verification code",
        timer: 2500,
      });
    } else {
      axios
        .post(`/sign-up-after-verification`, { ...userInfo, token: token })
        .then((res) => {
          console.log(res, "res");
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Success !",
            text: "Account created successfully",
            timer: 2500,
          });
          sessionStorage.setItem("user", JSON.stringify(res.data));
          setUpdate(!update);
          setIsSignedIn(true);
          if (cart.length > 0) {
            navigate(`/checkout/${pharmacyDataDetails.seller_id}`);
          } else {
            navigate(from.state ? from.state : "/");
          }
          setIsLoginOpen(false);
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            position: "top-center",
            icon: "error",
            title: "Error !",
            text: `${err.response.data.message}`,
            timer: 2500,
          });
        });
    }
  };

  return (
    <>
      {/* <section className="h-[90vh] flex flex-col md:flex-row justify-center space-y-10 md:space-y-0 md:space-x-16 items-center my-2 mx-5 md:mx-0 md:my-0">
                <div className="md:w-1/3 max-w-sm">
                    <img
                        src={login}
                        alt="Sample" />
                </div>
                <div className="md:w-1/3 max-w-sm">
                    <h1 className='text-4xl font-bold mb-4'>Login</h1>
                    <input onChange={(e) => setuserInfo({ ...userInfo, email: e.target.value })} className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded" type="text" placeholder="Email or Phone" />
                    <div className="relative">
                        <input onChange={(e) => setuserInfo({ ...userInfo, password: e.target.value })} className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4" type={isVissible ? "text" : "password"} placeholder="Password" />
                        {
                            isVissible ?
                                <i onClick={() => setIsVissible(!isVissible)} className="cursor-pointer fa-sharp fa-solid fa-eye-slash absolute inset-y-7 right-2"></i>
                                :
                                <i onClick={() => setIsVissible(!isVissible)} className="cursor-pointer fa-solid fa-eye absolute inset-y-7 right-2"></i>
                        }
                    </div>
                    <div className="mt-4 flex justify-between font-semibold text-sm">
                        <label className="flex text-slate-500 hover:text-slate-600 cursor-pointer">
                            <input onChange={(e) => setuserInfo({ ...userInfo, rememberme: !userInfo.rememberme })} className="mr-1" type="checkbox" />
                            <span >Remember Me</span>
                        </label>
                        <a className="text-blue-600 hover:text-blue-700 hover:underline hover:underline-offset-4" href={`${global.back_url}`}>Login as seller</a>
                    </div>
                    <div className="text-center md:text-left">
                        <button onClick={submitForm} className="mt-4 bg-blue-600 hover:bg-blue-700 px-4 py-2 text-white uppercase rounded text-xs tracking-wider" type="submit">Login</button>
                    </div>
                    <div className="mt-4 font-semibold text-sm text-slate-500 text-center md:text-left">
                        Don't have an account? <Link to="/register" className="text-red-600 hover:underline hover:underline-offset-4 cursor-pointer">Register</Link>
                    </div>
                </div>
            </section> */}

      <Modal
        isOpen={loginModalIsOpen}
        onRequestClose={() => setIsLoginOpen(false)}
        style={customStyles}
        contentLabel="our modal"
      >
        <div className="modal-header bg-white  py-2 px-2">
          <h6 className="text-lg font-bold mb-1">
            
            <HiOutlineX
              onClick={() => setIsLoginOpen(false)}
              className="inline float-right cursor-pointer"
            />
          </h6>
          {!isRegister ? (
            <section className=" flex flex-col md:flex-row justify-center space-y-10 md:space-y-0 md:space-x-16 items-center my-2 mx-5 md:mx-0 md:my-0">
              <div className="md:w-1/3 max-w-sm">
                <img src={login} alt="Sample" />
              </div>
              <div className="md:w-1/3 max-w-sm">
                <h1 className="text-3xl font-bold mb-4">Customer Login</h1>
                <input
                  onChange={(e) =>
                    setuserInfo({ ...userInfo, email: e.target.value })
                  }
                  className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded"
                  type="text"
                  placeholder="Email Address"
                />
                <input
                  onChange={(e) =>
                    setuserInfo({ ...userInfo, password: e.target.value })
                  }
                  className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4"
                  type="password"
                  placeholder="Password"
                />
                <div className="mt-4 flex justify-between font-semibold text-sm">
                  <label className="flex text-slate-500 hover:text-slate-600 cursor-pointer">
                    <input
                      onChange={(e) =>
                        setuserInfo({
                          ...userInfo,
                          rememberme: !userInfo.rememberme,
                        })
                      }
                      className="mr-1"
                      type="checkbox"
                    />
                    <span>Remember Me</span>
                  </label>
                  <a
                    className="text-blue-600 hover:text-blue-700 hover:underline hover:underline-offset-4"
                    href={`${global.back_url}`}
                  >
                    Login as seller
                  </a>
                </div>
                <div className="text-center md:text-left">
                  <button
                    onClick={submitForm}
                    className="mt-4 bg-blue-600 hover:bg-blue-700 px-4 py-2 text-white uppercase rounded text-xs tracking-wider"
                    type="submit"
                  >
                    Login
                  </button>
                </div>
                <div className="mt-4 font-semibold text-sm text-slate-500 text-center md:text-left">
                  Don't have an account?
                  <span
                    onClick={() => setIsRegister(!isRegister)}
                    className="text-red-600 hover:underline hover:underline-offset-4 cursor-pointer"
                  >
                    Register
                  </span>
                </div>
              </div>
            </section>
          ) : (
            <section className="flex flex-col md:flex-row justify-center space-y-10 md:space-y-0 md:space-x-16 items-center my-2 mx-5 md:mx-0 md:my-0">
              <div className="md:w-1/3 max-w-sm">
                <img src={login} alt="Sample" />
              </div>
              <div className="md:w-1/3 max-w-sm">
                <h1 className="text-2xl font-bold mb-2">Customer Register</h1>
                {!isCodeSend ? (
                  <>
                    <input
                      onChange={(e) =>
                        setuserInfo({
                          ...userInfo,
                          phone_number: e.target.value,
                        })
                      }
                      className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-2"
                      type="number"
                      placeholder="Phone Number"
                    />
                    <div className="text-center my-3">
                      <button
                        onClick={handleSendVerification}
                        className="bg-blue-600 hover:bg-blue-700 px-4 py-2 text-white uppercase rounded text-xs tracking-wider mb-2"
                        type="submit"
                      >
                        
                        Send Verification Code
                      </button>
                      <a
                        className="text-blue-600  hover:text-blue-700 hover:underline hover:underline-offset-4"
                        href={`${global.back_url}`}
                      >
                        Register as seller
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <input
                      value={userInfo.phone_number}
                      onChange={(e) =>
                        setuserInfo({
                          ...userInfo,
                          phone_number: e.target.value,
                        })
                      }
                      className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4"
                      type="number"
                      placeholder="Phone Number"
                    />
                    <input
                      onBlur={handleVerificationCheck}
                      onChange={(e) =>
                        setuserInfo({
                          ...userInfo,
                          verification_code: e.target.value,
                        })
                      }
                      className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4"
                      type="number"
                      placeholder="Verification Code"
                    />
                    {isVerified === "yes" && (
                      <>
                        <span className="text-blue-600">
                          Phone Number Verified
                        </span>
                      </>
                    )}
                    {isVerified === "no" && (
                      <>
                        <span className="text-red-600">
                          Invalid Verification Code
                        </span>
                      </>
                    )}
                    <input
                      onChange={(e) =>
                        setuserInfo({ ...userInfo, name: e.target.value })
                      }
                      className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4"
                      type="text"
                      placeholder="Name"
                    />
                    <input
                      onChange={(e) =>
                        setuserInfo({ ...userInfo, email: e.target.value })
                      }
                      className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4"
                      type="email"
                      placeholder="Email Address"
                    />

                    <div className="relative">
                      <input
                        onChange={(e) =>
                          setuserInfo({ ...userInfo, password: e.target.value })
                        }
                        className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4"
                        type={isVissible ? "text" : "password"}
                        placeholder="Password"
                      />
                      {isVissible ? (
                        <i
                          onClick={() => setIsVissible(!isVissible)}
                          className="cursor-pointer fa-sharp fa-solid fa-eye-slash absolute inset-y-7 right-2"
                        ></i>
                      ) : (
                        <i
                          onClick={() => setIsVissible(!isVissible)}
                          className="cursor-pointer fa-solid fa-eye absolute inset-y-7 right-2"
                        ></i>
                      )}
                    </div>
                    <div className="relative">
                      <input
                        onChange={(e) =>
                          setuserInfo({
                            ...userInfo,
                            password_confirmation: e.target.value,
                          })
                        }
                        className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4"
                        type={isVissible ? "text" : "password"}
                        placeholder="Confirm Password"
                      />
                      {isVissible ? (
                        <i
                          onClick={() => setIsVissible(!isVissible)}
                          className="cursor-pointer fa-sharp fa-solid fa-eye-slash absolute inset-y-7 right-2"
                        ></i>
                      ) : (
                        <i
                          onClick={() => setIsVissible(!isVissible)}
                          className="cursor-pointer fa-solid fa-eye absolute inset-y-7 right-2"
                        ></i>
                      )}
                    </div>
                    <div className="mt-4 flex justify-between font-semibold text-sm">
                      <div className="text-center md:text-left">
                        <button
                          onClick={submitRegForm}
                          className="bg-blue-600 hover:bg-blue-700 px-4 py-2 text-white uppercase rounded text-xs tracking-wider"
                          type="submit"
                        >
                          
                          Register
                        </button>
                      </div>
                      <a
                        className="text-blue-600 hover:text-blue-700 hover:underline hover:underline-offset-4"
                        href={`${global.back_url}`}
                      >
                        Register as seller
                      </a>
                    </div>
                  </>
                )}

                <div className="mt-4 font-semibold text-sm text-slate-500 text-center md:text-left">
                  Already have an account?
                  <span
                    onClick={() => setIsRegister(!isRegister)}
                    className="text-red-600 hover:underline hover:underline-offset-4 cursor-pointer"
                  >
                    Login
                  </span>
                </div>
              </div>
            </section>
          )}
        </div>
      </Modal>
    </>
  );
}

export default Login;
